import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2c55c64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cloth-main" }
const _hoisted_2 = { class: "top-bar" }
const _hoisted_3 = { class: "query-bar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "divider"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_9 = {
  "data-enter-scope": "query",
  class: "search-text"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_12 = { class: "top-bar-item" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "image-item" }
const _hoisted_18 = { class: "upload-image" }
const _hoisted_19 = { class: "upload" }
const _hoisted_20 = { class: "command" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "cover"
}
const _hoisted_23 = { class: "content" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正在实别图片并查询...", -1))
const _hoisted_25 = {
  key: 0,
  class: "qrcode-retry"
}
const _hoisted_26 = {
  key: 1,
  class: "qrcode"
}
const _hoisted_27 = { class: "item" }
const _hoisted_28 = { class: "content" }
const _hoisted_29 = { class: "catalog-status-slot" }
const _hoisted_30 = {
  key: 0,
  role: "status",
  style: {"padding":"8px 12px","color":"#666"}
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 2,
  class: "catalog-grid-spacer",
  style: {"width":"100px","height":"100px"}
}
const _hoisted_33 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PinnedFilter = _resolveComponent("PinnedFilter")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_image_viewer = _resolveComponent("image-viewer")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ClothCard = _resolveComponent("ClothCard")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _directive_enter_action = _resolveDirective("enter-action")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PinnedFilter, {
          modelValue: _ctx.clothCondition.pinned,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.clothCondition.pinned) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getAllProducts(1)))
        }, null, 8, ["modelValue"]),
        _hoisted_4,
        (_ctx.clientFunctionVisible('收藏列表'))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expend(0))),
              class: _normalizeClass(['search-normal',_ctx.isOpen.favorate?'open':'close'])
            }, [
              _createTextVNode("是否收藏 "),
              _createVNode(_component_svg_icon, { icon: "up" })
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.clientFunctionVisible('收藏列表'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expend(1))),
          class: _normalizeClass(['search-normal',_ctx.isOpen.season?'open':'close'])
        }, [
          _createTextVNode("季节 "),
          _createVNode(_component_svg_icon, { icon: "up" })
        ], 2),
        _hoisted_6,
        _createElementVNode("div", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expend(4))),
          class: _normalizeClass(['search-normal',_ctx.isOpen.category?'open':'close'])
        }, [
          _createTextVNode("服装分类 "),
          _createVNode(_component_svg_icon, { icon: "up" })
        ], 2),
        _hoisted_7,
        _createElementVNode("div", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.expend(2))),
          class: _normalizeClass(['search-normal',_ctx.isOpen.master?'open':'close'])
        }, [
          _createTextVNode("是否直营 "),
          _createVNode(_component_svg_icon, { icon: "up" })
        ], 2),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.getAllProducts(1)), ["enter"])),
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.clothCondition.searchValue) = $event)),
            placeholder: "请输入关健词查询"
          }, null, 544), [
            [_directive_enter_action, () => _ctx.getAllProducts(1), "query"],
            [_vModelText, _ctx.clothCondition.searchValue]
          ]),
          _createVNode(_component_svg_icon, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getAllProducts(1))),
            style: {"font-size":"16px"},
            icon: "search1"
          })
        ]),
        _hoisted_10,
        (_ctx.clientFunctionVisible('AI图片搜索'))
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.expend(5))),
              class: _normalizeClass(['search-img search-normal',_ctx.isOpen.imageSearching?'open':'close'])
            }, [
              _createVNode(_component_svg_icon, {
                icon: "camera",
                style: {"font-size":"18px","margin-right":"5px"}
              }),
              _createTextVNode("图片搜索 ")
            ], 2))
          : _createCommentVNode("", true),
        _hoisted_11,
        _createElementVNode("div", {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.expend(3))),
          class: _normalizeClass(['search-normal',_ctx.isOpen.order?'open':'close'])
        }, [
          _createTextVNode(" 排序方式 "),
          _createVNode(_component_svg_icon, { icon: "up" })
        ], 2),
        (!_ctx.isPad)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              style: {"cursor":"pointer"},
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.resetCondition && _ctx.resetCondition(...args)))
            }, "重置搜索"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", {
        class: _normalizeClass(['query-condition',(_ctx.isOpen.season || _ctx.isOpen.favorate || _ctx.isOpen.order || _ctx.isOpen.master || _ctx.isOpen.category || _ctx.isOpen.imageSearching)?'query-condition-expaned':''])
      }, [
        (_ctx.cType==0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['list',(_ctx.isOpen.favorate)?'list-out':''])
            }, [
              _createElementVNode("div", {
                onClick: _cache[12] || (_cache[12] = ()=>{_ctx.clothCondition.favorites='0';_ctx.getAllProducts(1)}),
                class: "item"
              }, "不限"),
              _createElementVNode("div", {
                onClick: _cache[13] || (_cache[13] = ()=>{_ctx.clothCondition.favorites='1';_ctx.getAllProducts(1)}),
                class: "item"
              }, "已收藏")
            ], 2))
          : (_ctx.cType==1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(['list',(_ctx.isOpen.season)?'list-out':''])
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_checkbox, {
                    checked: _ctx.season.a,
                    "onUpdate:checked": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.season.a) = $event)),
                    onChange: _ctx.setSeasonId
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("春")
                    ]),
                    _: 1
                  }, 8, ["checked", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_a_checkbox, {
                    checked: _ctx.season.b,
                    "onUpdate:checked": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.season.b) = $event)),
                    onChange: _ctx.setSeasonId
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("夏")
                    ]),
                    _: 1
                  }, 8, ["checked", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_a_checkbox, {
                    checked: _ctx.season.c,
                    "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.season.c) = $event)),
                    onChange: _ctx.setSeasonId
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("秋")
                    ]),
                    _: 1
                  }, 8, ["checked", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_a_checkbox, {
                    checked: _ctx.season.d,
                    "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.season.d) = $event)),
                    onChange: _ctx.setSeasonId
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("冬")
                    ]),
                    _: 1
                  }, 8, ["checked", "onChange"])
                ])
              ], 2))
            : (_ctx.cType==2)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(['list',(_ctx.isOpen.master)?'list-out':''])
                }, [
                  _createElementVNode("div", {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setProductSource(-1))),
                    class: "item"
                  }, "不限"),
                  _createElementVNode("div", {
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setProductSource(1))),
                    class: "item"
                  }, "直营"),
                  _createElementVNode("div", {
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setProductSource(2))),
                    class: "item"
                  }, "第三方")
                ], 2))
              : (_ctx.cType==3)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: _normalizeClass(['list',(_ctx.isOpen.order)?'list-out':''])
                  }, [
                    _createElementVNode("div", {
                      class: "item",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sort('title')))
                    }, "标题"),
                    _createElementVNode("div", {
                      class: "item",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.sort('retailPrice')))
                    }, "价格")
                  ], 2))
                : (_ctx.cType==5)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: _normalizeClass(['list',(_ctx.isOpen.imageSearching)?'list-out':''])
                    }, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageFiles, (image, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "img",
                                key: index
                              }, [
                                _createVNode(_component_image_viewer, {
                                  height: 80,
                                  width: 50,
                                  url: image.originalUrl,
                                  onDelimg: _ctx.deleteImage,
                                  onSearch: _ctx.search,
                                  fileType: image.fileType,
                                  id: image.id,
                                  oriUrl: image.originalUrl,
                                  index: image.index
                                }, null, 8, ["url", "onDelimg", "onSearch", "fileType", "id", "oriUrl", "index"])
                              ]))
                            }), 128)),
                            _createElementVNode("div", _hoisted_20, [
                              _createTextVNode(" 单击 "),
                              _createElementVNode("span", {
                                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.uploadImage()))
                              }, "上传图片"),
                              _createTextVNode(" 开始查询"),
                              (_ctx.qrcodeurl)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, " 或扫码上传"))
                                : _createCommentVNode("", true),
                              _createElementVNode("input", {
                                ref: "uploadfiles",
                                onChange: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.newImgChanged && _ctx.newImgChanged(...args))),
                                type: "file",
                                style: {"display":"none"}
                              }, null, 544)
                            ]),
                            (_ctx.isQuerying)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    _createVNode(_component_svg_icon, { icon: "loading" }),
                                    _hoisted_24
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.qrcodeError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.retryImageBridge && _ctx.retryImageBridge(...args)))
                                }, _toDisplayString(_ctx.qrcodeError), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.qrcodeurl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                (_ctx.qrcodeurl)
                                  ? (_openBlock(), _createBlock(_component_qrcode_vue, {
                                      key: 0,
                                      type: "image/png",
                                      color: { dark: '#000000', light: '#ffffff' },
                                      value: _ctx.qrcodeurl,
                                      size: 80
                                    }, null, 8, ["value"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 2))
                  : (_ctx.cType==4)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 5,
                        class: _normalizeClass(['list',(_ctx.isOpen.category)?'list-out':''])
                      }, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_a_checkbox_group, {
                            value: _ctx.clothCondition.categoryList,
                            "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.clothCondition.categoryList) = $event)),
                            onChange: _ctx.categoryChanged,
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_row, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryData, (item) => {
                                    return (_openBlock(), _createBlock(_component_a_col, {
                                      style: {"height":"30px"},
                                      span: 6,
                                      key: item.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_checkbox, {
                                          value: item.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.label), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value", "onChange"])
                        ])
                      ], 2))
                    : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        (_ctx.catalogError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              (!_ctx.bokes.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.catalogError), 1))
                : _createCommentVNode("", true),
              (_ctx.catalogError)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    size: "small",
                    loading: _ctx.catalogLoading,
                    onClick: _ctx.retryCatalog
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("重试")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['body',_ctx.isPad?'pad-body':''])
      }, [
        (_ctx.isPad)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.bokes, (item) => {
              return (_openBlock(), _createBlock(_component_ClothCard, {
                onCardClick: _ctx.cardClick,
                height: 440,
                width: 210,
                value: item,
                key: item.code
              }, null, 8, ["onCardClick", "value"]))
            }), 128))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.bokes, (item) => {
              return (_openBlock(), _createBlock(_component_ClothCard, {
                onCardClick: _ctx.cardClick,
                height: 480,
                width: 230,
                value: item,
                key: item.code
              }, null, 8, ["onCardClick", "value"]))
            }), 128)),
        (_ctx.bokes.length%5==1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_a_pagination, {
            current: _ctx.current,
            "onUpdate:current": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.current) = $event)),
            onChange: _ctx.getAllProducts,
            pageSize: _ctx.pageSize,
            "onUpdate:pageSize": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.pageSize) = $event)),
            total: _ctx.total
          }, null, 8, ["current", "onChange", "pageSize", "total"])
        ])
      ], 2)
    ]),
    ((_ctx.isOpen.master || _ctx.isOpen.season || _ctx.isOpen.favorate || _ctx.isOpen.order || _ctx.isOpen.category || _ctx.isOpen.imageSearching))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.closeAll && _ctx.closeAll(...args))),
          class: _normalizeClass(['cover',_ctx.coverShow?'cover-show':''])
        }, null, 2))
      : _createCommentVNode("", true)
  ]))
}